import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { ClaimAutopayType, DefaultClaimPayeeType } from '@/modules/employee/employee.types';
import { EMPLOYEE_QUERY_KEY } from '@/modules/employee/Employee/queries/useGetEmployeeByIdExtended.query';

import { EmployeeClaimAutopayPayload } from '../stores/useEmployeeClaimAutopay.store';

interface EmployeeClaimAutopayServerPayload {
  claim_autopay_type?: ClaimAutopayType;
  default_claim_payee_type?: DefaultClaimPayeeType;
}

const useUpdateEmployeeAutopayPropertiesQuery = (id: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (value: EmployeeClaimAutopayPayload) =>
      api.patch<EmployeeClaimAutopayServerPayload>(API_URL.EMPLOYEES_CLAIM_CONFIG_BY_EMPLOYEE_ID(id), {
        ...(value.claimAutopayType
          ? {
              claim_autopay_type: value.claimAutopayType,
            }
          : {}),
        ...(value.defaultClaimPayeeType
          ? {
              default_claim_payee_type: value.defaultClaimPayeeType,
            }
          : {}),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [{ queryKey: [EMPLOYEE_QUERY_KEY, id] }],
        });
      },
    }
  );
  return {
    updateEmployeeAutopayProperties: mutateAsync,
    isLoading,
  };
};

export default useUpdateEmployeeAutopayPropertiesQuery;
